// test2462
(2462 && 0);
